'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconShop = function IconShop(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M15.82,9.68 C16.06,9.68 16.28,9.80666667 16.4,10.0133333 C16.68,10.5066667 17.1733333,10.8 17.7333333,10.8 C18.5333333,10.8 19.2,10.18 19.2666667,9.38666667 L17.4066667,5.35333333 L6.28666667,5.35333333 L4.72,9.37333333 C4.78,10.1666667 5.44666667,10.8 6.26,10.8 C6.81333333,10.8 7.31333333,10.5066667 7.59333333,10.0133333 C7.83333333,9.6 8.51333333,9.6 8.75333333,10.0133333 C9.03333333,10.5066667 9.52666667,10.8 10.0866667,10.8 C10.64,10.8 11.14,10.5066667 11.42,10.0133333 C11.6533333,9.6 12.3333333,9.6 12.5733333,10.0133333 C12.8533333,10.5066667 13.3533333,10.8 13.9066667,10.8 C14.46,10.8 14.96,10.5066667 15.24,10.0133333 C15.36,9.80666667 15.58,9.68 15.82,9.68 Z M17.7333333,12.1333333 C17.02,12.1333333 16.34,11.86 15.82,11.3933333 C15.3,11.86 14.62,12.1333333 13.9066667,12.1333333 C13.1933333,12.1333333 12.5133333,11.86 11.9933333,11.3933333 C11.4733333,11.86 10.8,12.1333333 10.0866667,12.1333333 C9.37333333,12.1333333 8.69333333,11.86 8.17333333,11.3933333 C7.65333333,11.86 6.97333333,12.1333333 6.26,12.1333333 C4.67333333,12.1333333 3.38666667,10.84 3.38666667,9.25333333 C3.38666667,9.17333333 3.4,9.09333333 3.42666667,9.01333333 L5.20666667,4.44666667 C5.30666667,4.19333333 5.55333333,4.02 5.82666667,4.02 L17.8266667,4.02 C18.0866667,4.02 18.3266667,4.17333333 18.4333333,4.40666667 L20.5466667,8.97333333 C20.5866667,9.06666667 20.6066667,9.16 20.6066667,9.25333333 C20.6066667,10.84 19.3133333,12.1333333 17.7333333,12.1333333 L17.7333333,12.1333333 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M18.1066667,19.6733333 L5.88666667,19.6733333 C5.52,19.6733333 5.22,19.3733333 5.22,19.0066667 L5.22,11.6733333 C5.22,11.3066667 5.52,11.0066667 5.88666667,11.0066667 C6.25333333,11.0066667 6.55333333,11.3066667 6.55333333,11.6733333 L6.55333333,18.34 L17.44,18.34 L17.44,11.6733333 C17.44,11.3066667 17.74,11.0066667 18.1066667,11.0066667 C18.4733333,11.0066667 18.7733333,11.3066667 18.7733333,11.6733333 L18.7733333,19.0066667 C18.7733333,19.3733333 18.4733333,19.6733333 18.1066667,19.6733333' }),
      ' ',
      _react2.default.createElement('path', { d: 'M8.43333333,18.34 L15.5466667,18.34 L15.5466667,14.12 L8.43333333,14.12 L8.43333333,18.34 Z M15.88,19.0066667 L8.1,19.0066667 C7.91333333,19.0066667 7.76666667,18.86 7.76666667,18.6733333 L7.76666667,13.7866667 C7.76666667,13.6 7.91333333,13.4533333 8.1,13.4533333 L15.88,13.4533333 C16.06,13.4533333 16.2133333,13.6 16.2133333,13.7866667 L16.2133333,18.6733333 C16.2133333,18.86 16.06,19.0066667 15.88,19.0066667 L15.88,19.0066667 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M18.44,6.78666667 L5.60666667,6.78666667 C5.42666667,6.78666667 5.27333333,6.63333333 5.27333333,6.45333333 C5.27333333,6.26666667 5.42666667,6.12 5.60666667,6.12 L18.44,6.12 C18.6266667,6.12 18.7733333,6.26666667 18.7733333,6.45333333 C18.7733333,6.63333333 18.6266667,6.78666667 18.44,6.78666667' }),
      ' '
    )
  );
};

IconShop.propTypes = {
  color: _propTypes2.default.string
};

IconShop.defaultProps = {
  color: _colors2.default.icons
};

IconShop.displayName = 'IconShop';

exports.default = IconShop;
module.exports = exports.default;